import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { FormSelect } from "@/components/form";
import { DynamicForm } from "@/components/dynamic-form";
import { useEmrContext } from "@/hooks/emr-context";
import { useDynamicForm, useForm, useFormsList, useSaveForm } from "@/hooks/form";
import { useComposerStore } from "@/stores/composers";
import { useCompleteActionFromComposer } from "@/hooks/tasks";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { buildSubmitPayload, SCORED_FORMS } from "@/utils/form";
import { parseFormComposerContent } from "./parse-composer-content";
import { ComposerShell } from "./composer-shell";
/** Form composer: pick a template, fill its dynamic fields, and submit. */
export function FormComposerBody(_ref) {
  var _formsQuery$data$form, _formsQuery$data2;
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var _useState = useState(null),
    selectedForm = _useState[0],
    setSelectedForm = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(function () {
      return parseFormComposerContent(composer.content);
    }),
    initialContent = _useState3[0];
  var formsQuery = useFormsList(patientUid);
  useEffect(function () {
    if (!composer.initialTemplateId || !formsQuery.data) return;
    var match = formsQuery.data.forms.find(function (f) {
      return f.id === composer.initialTemplateId;
    });
    if (match) setSelectedForm(match.name);
  }, [composer.initialTemplateId, formsQuery.data]);
  var formQuery = useForm(patientUid, selectedForm);
  var form = formQuery.data;
  useEffect(function () {
    var _formsQuery$data;
    var id = initialContent === null || initialContent === void 0 ? void 0 : initialContent.formId;
    if (!id || selectedForm) return;
    var match = (_formsQuery$data = formsQuery.data) === null || _formsQuery$data === void 0 ? void 0 : _formsQuery$data.forms.find(function (f) {
      return f.id === id;
    });
    if (match) setSelectedForm(match.name);
  }, [formsQuery.data, initialContent, selectedForm]);
  var dynamic = useDynamicForm(form, initialContent === null || initialContent === void 0 ? void 0 : initialContent.formResponse);
  var saveForm = useSaveForm(patientUid);
  var completeAction = useCompleteActionFromComposer(composer.actionMeta);
  var options = ((_formsQuery$data$form = (_formsQuery$data2 = formsQuery.data) === null || _formsQuery$data2 === void 0 ? void 0 : _formsQuery$data2.forms) !== null && _formsQuery$data$form !== void 0 ? _formsQuery$data$form : []).map(function (item) {
    return {
      value: item.name,
      label: item.display_name || item.name
    };
  });
  var showScore = Boolean(form && SCORED_FORMS.has(form.name));
  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _buildSubmitPayload, payload, mediaFiles, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (form) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setError(null);
            _buildSubmitPayload = buildSubmitPayload(dynamic.schema, dynamic.response, form.name, form.display_name), payload = _buildSubmitPayload.payload, mediaFiles = _buildSubmitPayload.mediaFiles;
            _context.p = 2;
            _context.n = 3;
            return saveForm.mutateAsync({
              formName: form.name,
              payload: payload,
              mediaFiles: mediaFiles
            });
          case 3:
            completeAction();
            close(composer.id);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setError(t("form_save_failed", {
              defaultValue: "Could not save the form. Please try again."
            }));
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function submit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: (form === null || form === void 0 ? void 0 : form.display_name) || composer.title,
    subtitle: composer.subtitle,
    footer: /*#__PURE__*/React.createElement("div", {
      className: "flex w-full items-center justify-between gap-3"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-small text-sds-base-secondary"
    }, showScore ? "".concat(t("total_score", {
      defaultValue: "Total score"
    }), ": ").concat(dynamic.score) : ""), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-cancel-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CANCEL, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "composer-save-".concat(composer.id),
      loading: saveForm.isLoading,
      disabled: !form || !dynamic.submittable,
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_SAVE, {
          composerId: composer.id
        });
        void submit();
      }
    }, t("submit", {
      defaultValue: "Submit"
    }))))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    label: t("select_form", {
      defaultValue: "Form"
    }),
    placeholder: t("select_form_placeholder", {
      defaultValue: "Select a form"
    }),
    data: options,
    value: selectedForm,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.FORM_SELECT, {
        composerId: composer.id
      });
      setSelectedForm(value);
    },
    searchable: true,
    withinPortal: true,
    nothingFound: t("no_form_available", {
      defaultValue: "No form available"
    }),
    disabled: Boolean(formsQuery.isLoading || composer.lockTemplate),
    "data-testid": "form-select"
  }), !selectedForm ? /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-48 items-center justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-base text-sds-base-tertiary"
  }, t("select_form_to_start", {
    defaultValue: "Select a form to start"
  }))) : formQuery.isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-48 items-center justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-tertiary"
  }, t("loading", {
    defaultValue: "Loading…"
  }))) : form ? /*#__PURE__*/React.createElement("div", {
    className: "min-h-96"
  }, /*#__PURE__*/React.createElement(DynamicForm, {
    schema: dynamic.schema,
    layout: form.schema.layout,
    response: dynamic.response,
    tags: dynamic.tags,
    onFieldChange: dynamic.setFieldValue
  })) : null, error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-urgent-secondary"
  }, error) : null));
}